export enum ASearchBarTabType {
  items = 'items',
  pinned = 'pinned',
  channels = 'channels',
  people = 'people',
  explore = 'explore'
}
